import * as actionConsts from './actions';
import update from 'react/lib/update';

export const initState = {
  feeds: []
}


export default (state = initState, action) => {
  switch (action.type) {
    case actionConsts.GET_WORKPLACE_ACTIVITYFEEDS_SUCCESS:
      return update(state, {
        feeds: {
          $push: action.feeds
        }
      });
    case actionConsts.GET_WORKPLACE_ACTIVITYFEEDS_SUCCESS_INIT:
      return update(state, {
        feeds: {
          $set: action.feeds
        }
      });

    case 'KILL_WORKPLACE':
      return initState

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/Feed/reducer.js